export default "__VITE_ASSET__awrQz3_J__"